<template>
  <div style="height: 100%">
    <v-card class="shadow" style="height: 100%">
      <div class="d-flex justify-space-between align-center bs-py-3 bs-px-4">
        <h3>Daily Bets</h3>
        <v-btn
          text
          class="text-uppercase px-4"
          @click="filterDialog = true"
          :disabled="betsDailyStatisticsLoading"
        >
          {{ betsDailyStatistics.label }}
        </v-btn>
      </div>
      <v-divider></v-divider>

      <div class="d-flex align-center justify-center pa-6">
        <div v-if="betsDailyStatisticsLoading" class="text-center" style="height: 100%">
          <div class="d-flex align-center" style="gap: 1rem">
            <v-progress-circular
              :size="20"
              :width="3"
              color="secondary"
              indeterminate
            ></v-progress-circular>
            <span>Fetching chart information</span>
          </div>
        </div>
        <div style="width: 100%" v-else>
          <LineChart :theChartData="betsDailyStatistics" style="margin-top: -15px" />
        </div>
      </div>

      <div v-if="!betsDailyStatisticsLoading">
        <v-divider></v-divider>

        <div class="pa-6">
          <v-row class="text-center">
            <v-col md="4">
              <div class="d-flex justify-center" style="gap: 1rem">
                <div>
                  <div class="mb-2" style="margin-top: 3px; font-size: 13px">Average</div>
                  <h3 style="color: #00b6fe">
                    {{
                      betsDailyStatistics.bet_daily_average
                        ? `${moneyFormat(
                            parseInt(betsDailyStatistics.bet_daily_average)
                          )}`
                        : "0"
                    }}
                  </h3>
                </div>
              </div>
            </v-col>
            <v-col md="4">
              <div class="d-flex justify-center" style="gap: 1rem">
                <div>
                  <div class="mb-2" style="margin-top: 3px; font-size: 13px">Lowest</div>
                  <h3 style="color: #00b6fe">
                    {{
                      betsDailyStatistics.bet_daily_average && lowest
                        ? `${moneyFormat(parseFloat(lowest))}`
                        : "0"
                    }}
                  </h3>
                </div>
              </div>
            </v-col>
            <v-col md="4">
              <div class="d-flex justify-center" style="gap: 1rem">
                <div>
                  <div class="mb-2" style="margin-top: 3px; font-size: 13px">Highest</div>
                  <h3 style="color: #00b6fe">
                    {{
                      betsDailyStatistics.bet_daily_average && highest
                        ? `${moneyFormat(parseFloat(highest))}`
                        : "0"
                    }}
                  </h3>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <v-dialog
      ref="filterDialog"
      v-model="filterDialog"
      :return-value.sync="month"
      persistent
      width="290px"
    >
      <v-date-picker v-model="month" full-width type="month">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancelFilter"> Cancel </v-btn>
        <v-btn text color="primary" @click="saveFilter"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import formatDatev2 from "@/helpers/formatDatev2";
import LineChart from "@/components/dashboard/bets_statistics/BetsDailyLineChart.vue";

export default {
  components: { LineChart },
  data: () => ({
    month: formatDatev2(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      "format",
      "yyyy-MM"
    ),
    filterDialog: false,
    activePicker: null,
  }),
  computed: {
    ...mapState(["accountInfo"]),
    ...mapState("dashboard", ["betsDailyStatistics", "betsDailyStatisticsLoading"]),

    lowest() {
      const arr = Object.values(this.betsDailyStatistics.bet_statistics);
      const filtered_array = arr.filter((val) => val != 0);

      if (filtered_array.length != 0) return Math.min(...filtered_array);

      return 0;
    },

    highest() {
      const arr = Object.values(this.betsDailyStatistics.bet_statistics);
      return Math.max(...arr);
    },
  },
  mounted() {
    if (this.accountInfo.access.includes(21)) {
      this.doGetData();
    }
  },
  props: {
    game_id: Number,
  },
  methods: {
    ...mapActions("dashboard", ["getBetsDailyStatistics"]),
    cancelFilter() {
      this.filterDialog = false;
    },
    saveFilter() {
      this.$refs.filterDialog.save(this.month);
      this.doGetData();
    },
    async doGetData() {
      if (!this.betsDailyStatisticsLoading) {
        const requestedGameId = this.game_id;
        this.$store.commit("dashboard/setBetsDailyStatistics", []);

        const formData = new FormData();
        formData.append("game_id", this.game_id);
        formData.append("val", this.month);
        formData.append("type", "Daily");

        const getData = new URLSearchParams(formData);

        await this.getBetsDailyStatistics(getData);
        if (this.game_id !== requestedGameId) {
          this.doGetData();
        }
      }
    },
    moneyFormat(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
  },
  watch: {
    game_id() {
      if (this.accountInfo.access.includes(21)) {
        this.doGetData();
      }
    },
  },
};
</script>
